import * as nsi from './nsi.ts';
globalThis.nsi = nsi;
